import React from "react";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

const TextWithHeading = ({ doc }) => {
  const { heading, text, internal_link_id } = doc?.primary || {};
  return (
    <div className="p-md-5 p-2xl-5 py-4 px-3 cs-content-section prismic-slice text-with-heading-slice">
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container container-width">
        <div className="sns-h2 text-theme-primary mb-3 mb-2xl-3 text-with-heading-slice-title same-size-title">
          {textResolver(heading)}
        </div>
        <div className="mt-4 mx-auto sns-h5 cs-content-text">{textResolver(text)}</div>
      </div>
    </div>
  );
};

export default TextWithHeading;
